import React from "react";
import {
  formatDateMobile,
  formatDateTimeToLocalTime
} from "../../../utils/helper";
import { IItemCardMessageProps } from "./itemCardMessage.props";
import { SmallButton } from "./itemCardMessage.styled";
import { OFFERING_TYPE, OFFERING_TYPE_NAME } from "../../../utils/constant";

const ItemCardMessageView: React.FC<IItemCardMessageProps> = ({
  data,
  isReceivedTab,
  ...props
}: IItemCardMessageProps) => {

  return (
    <div
      className="px-[20px] py-[10px] w-full text-[#637381] h-[120px]"
    >
      <div className={`flex flex-nowrap justify-between items-center ${
            isReceivedTab && !data.isReaded ? "font-bold" : ""
          }`}>
        <p
          className={`text-[0.875rem] text-[#58585B] line-clamp-1 max-w-[160px] ${
            isReceivedTab && !data.isReaded ? "font-bold" : "font-medium"
          }`}
        >
          {isReceivedTab
            ? `${data.fkFromIndividual?.firstName} ${data.fkFromIndividual?.lastName}`
            : `${data.inboxRecipientsMappings
                ?.map((e) => `${e.fkToIndividual?.firstName} ${e.fkToIndividual?.lastName}`)
                .join("; ")}`}
        </p>
        <p
          className={`text-[0.75rem] ${
            isReceivedTab && !data.isReaded ? "font-bold" : ""
          }`}
        >
          {formatDateMobile(formatDateTimeToLocalTime(data.sendDate))}
          {/* <a role="button" className="ml-3 mr-3 focus:ring focus:ring-blue-300 link-redirect">Edit</a>
          <a role="button" className="focus:ring focus:ring-blue-300 link-redirect">Delete</a> */}
        </p>
      </div>
      <div className="flex flex-col mt-[5px]">
        <p
          className={`text-[0.875rem] line-clamp-1 ${
            isReceivedTab && !data.isReaded ? "font-bold" : "font-normal"
          }`}
        >
          {data.subject}
        </p>
      </div>
      <div className="flex mt-[20px] mb-[10px]">
        <div className="flex items-center mr-[10px] w-[150px]">
          <p className="text-[12px] font-bold mr-[5px]">Offering:</p>
          <SmallButton>{data.fkComOffering?.fkOfferingType?.offeringTypeName?.toUpperCase() ??
            data?.fkInquiry?.fkMainService?.fkOfferingType?.offeringTypeName?.toUpperCase() ??
            data?.fkInquiry?.otherNavigation?.offeringTypeName?.toUpperCase() ?? "N/A"
            }</SmallButton>
        </div>
        <div>
          <div className="flex items-center mr-[10px] w-[150px]">
            <p className="text-[12px] font-bold mr-[5px]">Status:</p>
            <SmallButton>{data.fkInquiryStatus?.status?.toUpperCase() ?? "N/A"}</SmallButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(ItemCardMessageView);
